import L from 'leaflet';
import 'leaflet-realtime';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';

import {
    ENDPOINT_DATA_GEOSERVICIOS,
    PointColors,
    REALTIME_INTERVAL_SECONDS
} from '../../../constants';
import { dataGeoServiciosFetch } from '../../../helpers/fetch';
import { invertCoordinates } from '../../../helpers/generalFunctions';


/**
 * Get radius circle 
 * @param {Number} idCliente id of client
 * @param {String} colorPoints Color circle
 * @param {string} ptws - tws a mostrar en mapa
 * @returns {Array}Array of two elements: points circlesLayerGroup and circle realtime reference, the reference needs to be returned
 * to stop the subscription later.
 */
const getCircleRadiusLayerGroupRealTime = (idCliente, colorPoints, ptws) => {
    
    const widthCircle = 0.9;
    const circlesLayerGroup = new L.LayerGroup();

    const realtimeReference = L.realtime(
        {
            url: ENDPOINT_DATA_GEOSERVICIOS,
            method: 'POST',
            body: JSON.stringify({
                solicitud: 'Puntos',
                idCliente: idCliente,
                ptws: ptws,
            }),
        },
        {
            container: circlesLayerGroup,
            interval: REALTIME_INTERVAL_SECONDS * 1000,
            pointToLayer: (feature, latlng) => (
                L.layerGroup([
                    L.circle(latlng, {
                        radius: feature.properties.raoc * 1000,
                        color: getRadiusColor(feature,colorPoints),
                        fill: false,
                        weight: widthCircle,
                    }),
                    L.circle(latlng, {
                        radius: feature.properties.rma * 1000,
                        color: getRadiusColor(feature,colorPoints),
                        fill: false,
                        weight: widthCircle,
                    }),
                    L.circle(latlng, {
                        radius: feature.properties.rca * 1000,
                        color: getRadiusColor(feature,colorPoints),
                        fill: false,
                        weight: widthCircle,
                    })
                ])
            ),
            removeMissing: true,
            updateFeature: (feature, oldLayer, newLayer) => newLayer,
        }
    );
    return [circlesLayerGroup, realtimeReference];
}


const getCircleRadiusLayerGroupHistoric = async (parameters) => {
    const radiusGeojson = await dataGeoServiciosFetch(parameters, 'POST');
    const radiusMarkers = radiusGeojson.features.map((feature) => 
        creteRaidusMaker(
             invertCoordinates(feature.geometry.coordinates),
             feature,
        )
    )
    const raudiusLayerGroup = new L.LayerGroup(radiusMarkers);
    return raudiusLayerGroup
}

const creteRaidusMaker = ( latlng ,feature) => {
    const widthCircle = 0.9;
    return L.layerGroup([
        L.circle(latlng, {
            radius: feature.properties.raoc * 1000,
            color: PointColors[0].fill,
            fill: false,
            weight: widthCircle,
        }),
        L.circle(latlng, {
            radius: feature.properties.rma * 1000,
            color: PointColors[0].fill,
            fill: false,
            weight: widthCircle,
        }),
        L.circle(latlng, {
            radius: feature.properties.rca * 1000,
            color: PointColors[0].fill,
            fill: false,
            weight: widthCircle,
        })
    ])
};

/**
 * Colors for the radius
 * @param {object} feature - Object with level property
 * @param {string} color - Color selector for the points
 * @returns {String} Lightning color, based on "nivel" property.
 */
 const getRadiusColor = (feature,color) => {     
    const colorSelector = color.split(',')
    
    if (feature.properties.nivel === 3) {
        return colorSelector[3]
    } else if (feature.properties.nivel === 2) {
        return colorSelector[2]
    }else if (feature.properties.nivel === 1) {
        return colorSelector[1]
    }else if (feature.properties.nivel === 0) {
        return colorSelector[0]
    }else{
        return '#000000'
    }
};

export { getCircleRadiusLayerGroupRealTime , getCircleRadiusLayerGroupHistoric }


